export const educationData = {
        certification:[
            {
                title: "Full Stack Development",
                institution: "GUVI GEEK Private Limited",
                desription: "MERN Stack Development",
                time: "July 2023 - Sep 2023"
            }
        ],
        degree:[
            {
                title: "BCA",
                institution: "Bon Secours College for Women",
                desription: "Bachelor of Computer Application",
                time: "2015 - 2018"
            },
            {
                title: "Higher Secondary",
                institution: "St. Marcina's Matric Higher Secondary School",
                desription: "12th Grade in Maths-Biology",
                time: "2015"
            },

        ]
    }